var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfrastructure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PwC_Pictogram_Infrastructure_Black_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.23,0V144h144V0ZM52.28,43.05H90.75l45.48,94.81H8.17ZM6.37,127.15V43.05H45.5Zm91.21-84.1h40.51v84.47ZM138.09,6.14V36.9H6.37V6.14Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.16,
    y: 114.01,
    width: 6.15,
    height: 16.79
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.16,
    y: 87.81,
    width: 6.15,
    height: 14.79
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69.16,
    y: 65.78,
    width: 6.15,
    height: 12.79
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 69.16,
    y: 47.14,
    width: 6.15,
    height: 11.24
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructure);
export default __webpack_public_path__ + "static/media/infrastructure.d152675570b92b01eeabdab2569a0b56.svg";
export { ForwardRef as ReactComponent };